import * as actionTypes from '../actions'
const initialState = {
  cities : [],
  departaments: [],
  providers: [],
  LoadError: false,
  editProd: null,
  showPoppup: false,
  citySelected: false,
  selectedCity: {
    codigoDane: "11001000",
    nombre: "BOGOTÁ D.C.",
    departamento: "BOGOTÁ"
  },
  requestQuote: [],
  showShippingModal: false,
  errorQuote: "",
  showCityChangedModal: false,
  CityChangeModalAlert: false,
  CityChangeAlert: false,
  showAlertSelectedCity: false,
}


const elogisticaReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_CITIES: {
      return {
        ...state,
        cities: action.payload.cities,
      }
    }
    case actionTypes.LOAD_DEPARTAMENTS: {
      return {
        ...state,
        departaments: action.payload.departaments,
      }
    }
    case actionTypes.LOAD_ERROR: {
      return {
        ...state,
        LoadError: action.payload.LoadError,
      }
    }
    case actionTypes.TOGGLE_POPPUP: {
      return {
        ...state,
        showPoppup: !state.showPoppup,
      }
    }
    case actionTypes.TOGGLE_SHIPPINGMODAL: {
      return {
        ...state,
        showShippingModal: action.payload,
      }
    }
    case actionTypes.TOGGLE_CITYCHANGED: {
      return {
        ...state,
        showCityChangedModal: !state.showCityChangedModal,
      }
    }
    

    case actionTypes.TOGGLE_SHOWALERTSELECTEDCITY: {
      return {
        ...state,
        showAlertSelectedCity: !state.showAlertSelectedCity,
      }
    }

    case actionTypes.TOGGLE_CITYCHANGEMODALALERT: {
      return {
        ...state,
        CityChangeModalAlert: !state.CityChangeModalAlert,
      }
    }

    case actionTypes.TOGGLE_CITYCHANGEALERT: {
      return {
        ...state,
        CityChangeAlert: !state.CityChangeAlert,
      }
    }

    case actionTypes.REQUEST_QUOTE: {
      return {
        ...state,
        requestQuote: [...state.requestQuote, ...action.payload]
      }
    }
    case actionTypes.ONCHANGE_DEFAULT_CITY: {
      return {
        ...state,
        selectedCity: action.payload,
      }
    }
    case actionTypes.LOAD_PROVIDERS: { 
      return {
        ...state,
        providers: action.payload.providers,
      }
    }
    case actionTypes.RESET_QUOTE: { 
      return {
        ...state,
        requestQuote: [],
        LoadError: false
      }
    }
    case actionTypes.LOAD_ERROR_QUOTE: { 
      return {
        ...state,
        errorQuote: action.payload,
      }
    }
    case actionTypes.LOAD_EDIT_PROD: { 
      return {
        ...state,
        editProd: action.payload,
      }
    }
    default: {
      return state
    }
  }
}

export default elogisticaReducer
